module.exports = __webpack_public_path__ + "static/NotoSans-Regular-4f24c2d1aa1d559e5ab694c5af183358.woff2";